import { memo, useEffect } from "react";
import { useAtom, useAtomValue } from 'jotai';
import { headerCenter_currentState_Atom, HeaderCenter_State } from "../store";
import { elementType_Atom } from "./store";
import { TerraDrawMode_Enum, TerraDrawUtil } from "~/components/MapDraw/TerraDrawUtil";
import { isMapLoadedDoneAtom } from "~/components/Map/stores/mapStore";
import { mapElementTypeToTerraDrawMode } from "~/components/Map/utils/keyboardShortcutUtils";

const ElementHeaderController = () => {
  const [headerCenter_CurrentState] = useAtom(headerCenter_currentState_Atom);
  const elementMode = useAtomValue(elementType_Atom);
  const isMapLoadedDone = useAtomValue(isMapLoadedDoneAtom);

  useEffect(() => {
    if (!window.map) return;

    if (headerCenter_CurrentState === HeaderCenter_State.ELEMENT) {
      if (!window.draw) {
        try {
          TerraDrawUtil.setup();
        } catch (err) {
          console.warn('ElementHeaderController - TerraDraw setup warning:', err);
        }
      }
      if (window.draw && !window.draw.enabled) {
        try {
          window.draw.start();
        } catch (err) {
          console.warn('ElementHeaderController - TerraDraw start warning:', err);
        }
      }
      if (window.draw && window.draw.enabled) {
        const targetMode = mapElementTypeToTerraDrawMode(elementMode);
        if (window.draw.getMode() !== targetMode) {
          try {
            window.draw.setMode(targetMode);
          } catch (err) {
            console.warn('ElementHeaderController - TerraDraw setMode warning:', err);
          }
        }
      }
    } else {
      if (window.draw && window.draw.enabled) {
        if (window.draw.getMode() !== TerraDrawMode_Enum.SELECT) {
          try {
            window.draw.setMode(TerraDrawMode_Enum.SELECT);
          } catch (err) {
            console.warn('ElementHeaderController - TerraDraw setMode SELECT warning:', err);
          }
        }
      }
    }
  }, [headerCenter_CurrentState, elementMode, isMapLoadedDone]);

  return null;
};

export default memo(ElementHeaderController);
